import DashboardMethods from './DashboardMethods.js'

export const dashboardMethods = { ...DashboardMethods }
export * from './DashboardsConstants.js'
